module.exports = __webpack_public_path__ + "static/testimonial-3-4aad41c5b740f83115fb8fcaa55b3d63.png";